import '../../HelpLayout/SuccessModalStyles.scss';

import type React from 'react';

interface SubmissionSuccessModalProps {
	show: boolean;
	onClose: () => void;
	children: React.ReactNode;
}

const SubmissionSuccessModal: React.FC<SubmissionSuccessModalProps> = ({
	show,
	children,
}) => {
	if (!show) {
		return null;
	}

	return (
		<div className='modal-backdrop'>
			<div className='modal-content'>{children}</div>
		</div>
	);
};

export default SubmissionSuccessModal;
